import { render, staticRenderFns } from "./FamilyMessageReplyDetail.vue?vue&type=template&id=789afa34&lang=pug"
import script from "./FamilyMessageReplyDetail.vue?vue&type=script&lang=ts"
export * from "./FamilyMessageReplyDetail.vue?vue&type=script&lang=ts"
import style0 from "./FamilyMessageReplyDetail.vue?vue&type=style&index=0&id=789afa34&prod&lang=scss&scopeed=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports